// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Airtable = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Airtable = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Airtable = _exports.Airtable = function Airtable(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/_react["default"].createElement("g", {
      "clip-path": "url(#clip0_49_14381)"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M8.93604 1.68793L1.47474 4.77527C1.05983 4.94699 1.06412 5.53645 1.48164 5.70194L8.97405 8.67311C9.63234 8.93419 10.3655 8.93419 11.0238 8.67311L18.5163 5.70183C18.9337 5.53645 18.9382 4.9471 18.5231 4.77538L11.062 1.68782C10.3813 1.40614 9.61663 1.40614 8.93593 1.68782",
      fill: "#212B36"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M10.6641 10.2956V17.7181C10.6641 18.071 11.02 18.3128 11.3482 18.1827L19.697 14.9421C19.7901 14.9052 19.87 14.8412 19.9263 14.7583C19.9826 14.6755 20.0126 14.5776 20.0126 14.4774V7.05505C20.0126 6.70201 19.6566 6.46028 19.3285 6.59036L10.9797 9.83098C10.8866 9.86792 10.8067 9.93196 10.7504 10.0148C10.6942 10.0977 10.6641 10.1955 10.6641 10.2957",
      fill: "#212B36"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M8.71442 10.6775L6.23668 11.8738L5.9851 11.9954L0.754727 14.5015C0.423289 14.6615 0 14.4199 0 14.0516V7.08503C0 6.95178 0.0683236 6.83674 0.15995 6.7502C0.197539 6.71277 0.240184 6.68079 0.286642 6.65518C0.411525 6.58019 0.5898 6.56016 0.741379 6.62012L8.6728 9.76278C9.07595 9.92272 9.10762 10.4876 8.71442 10.6776",
      fill: "#212B36"
    })), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("clipPath", {
      id: "clip0_49_14381"
    }, /*#__PURE__*/_react["default"].createElement("rect", {
      width: "20",
      height: "20",
      fill: "white"
    }))));
  };
});
